import {
  ExperimentNames,
  TicketWithFormattedSalePeriod,
  getEventId,
  isDraft,
  isTicketed,
} from '@wix/wix-events-commons-statics'
import {isEditor, isPreview, isSite} from '../../../../commons/selectors/environment'
import {isDemoMode} from '../../../../commons/selectors/instance'
import {getEvent, isDemoEvent} from '../selectors/event'
import {inDetails, isEventPreview} from '../selectors/navigation'
import {createAsyncAction} from '../services/redux-toolkit'
import {State} from '../types/state'

export const REFRESH_AVAILABLE_TICKETS = 'REFRESH_AVAILABLE_TICKETS'

const getRefreshableEventId = (state: State) => {
  const event = getEvent(state)

  if (
    !event ||
    !isSite(state) ||
    isEditor(state) ||
    isPreview(state) ||
    isEventPreview(state) ||
    isDemoEvent(state) ||
    isDemoMode(state.instance) ||
    !inDetails(state) ||
    !isTicketed(event) ||
    isDraft(event)
  ) {
    return undefined
  }

  return getEventId(event)
}

export const refreshAvailableTickets = createAsyncAction<TicketWithFormattedSalePeriod[] | undefined>(
  REFRESH_AVAILABLE_TICKETS,
  async (_, {getState, extra: {serverApi}}) => {
    let eventId = getRefreshableEventId(getState())

    while (eventId) {
      try {
        const tickets = await serverApi.getAvailableFormattedTickets(eventId)
        const currentEventId = getRefreshableEventId(getState())

        if (!currentEventId) {
          return undefined
        }

        if (currentEventId === eventId) {
          return tickets
        }

        eventId = currentEventId
      } catch (error) {
        const currentEventId = getRefreshableEventId(getState())

        if (currentEventId && currentEventId !== eventId) {
          eventId = currentEventId
          continue
        }

        throw error
      }
    }

    return undefined
  },
  {
    condition: (_, {getState, extra: {flowAPI}}) => {
      const state = getState()

      return (
        flowAPI.experiments.enabled(ExperimentNames.refreshAvailableTickets) &&
        Boolean(getRefreshableEventId(state)) &&
        !state.pendingRequests.loading[REFRESH_AVAILABLE_TICKETS]
      )
    },
  },
)
